import React, { PureComponent, PropTypes } from 'react'
import { intlShape } from 'react-intl'
import { Link } from 'react-router'
import MiniPlayer from '../../components/miniPlayer/MiniPlayer'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'
import * as shapes from '../../constant/shapes'
import appConst from '../../constant/appConst'

class FocusAlbumBloc extends PureComponent {

	render() {
		const { album, current, playing } = this.props

		const releaseYear = new Date(album.released_at * 1000).getFullYear()
		let description = ''
		if (album.description) {
			if(album.description.length > appConst.albumBlocDescMaxLength) {
				const maxPos = album.description.lastIndexOf(' ', appConst.albumBlocDescMaxLength)
				description = `${album.description.substring(0, maxPos)}...`
			} else {
				description = album.description
			}
		}

		return (
			<div className={`item ${current ? (playing ? 'isPlaying' : 'isPause' ) : ''}`}>
				<div className="item-cover">
					<div className="item-action">
						<Link to={`/album/${album.id}`} className="item-cover-link" />
						<MiniPlayer
							element={album}
							buttonClassName="bt1 white item-play"
							type={ORIGIN_PLAYQUEUE_TYPES.album}
							sampleable={album.sampleable}
						/>
					</div>
					<div className="item-overlay" />
					{album.image ? <img src={album.image} alt="" height="295" width="295" /> : ''}
				</div>
				<p className="t3 mb10 mt10">
					<Link to={`/album/${album.id}`}>
						{`${album.title} (${releaseYear})`}
					</Link>
				</p>
				{album.artist ? <p className="c3">{album.artist.name}</p> : ''}
				{description ? <Link to={`/album/${album.id}`}>
					<p dangerouslySetInnerHTML={{ __html: `${description}`.nl2br() }} />
				</Link> : ''}
			</div>
		)
	}
}

FocusAlbumBloc.propTypes = {
	album: shapes.albumCard,
	current: PropTypes.bool,
	playing: PropTypes.bool
}

FocusAlbumBloc.contextTypes = {
	intl: intlShape
}

export default FocusAlbumBloc



// WEBPACK FOOTER //
// ./src/pages/focus/FocusAlbumBloc.jsx